import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { MatTableModule } from '@angular/material/table';
import { MaterialCatalogListTableComponent } from './material-catalog-list-table.component';
import { ColumnSelectionModule } from '../../../columns/column-selection/column-selection.module';
import { FilterSelectionModule } from '../../../filter/filter-selection/filter-selection.module';
import { MatRowKeyboardSelectionModule } from '../../../../core/directive/mat-row-keyboard-selection.module';
import { ResizeColumnModule } from '../../../../core/directive/resize-column.module';
import { MatSortModule } from '@angular/material/sort';

@NgModule({
  declarations: [MaterialCatalogListTableComponent],
  imports: [
    CommonModule,
    IonicModule,
    TranslateModule,
    MatTableModule,
    ColumnSelectionModule,
    FilterSelectionModule,
    MatRowKeyboardSelectionModule,
    ResizeColumnModule,
    MatSortModule,
  ],
  exports: [MaterialCatalogListTableComponent],
  providers: [],
})
export class MaterialCatalogListTableModule {}
